import { render, staticRenderFns } from "./DocumentsInReview.vue?vue&type=template&id=1544e51a&scoped=true&"
var script = {}
import style0 from "./DocumentsInReview.vue?vue&type=style&index=0&id=1544e51a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544e51a",
  null
  
)

export default component.exports